import $ from "jquery";
//#region TZ Data
var winTZ = [
	/*000*/ "(UTC-12:00) International Date Line West",
	/*001*/ "(UTC-11:00) Coordinated Universal Time-11",
	/*002*/ "(UTC-10:00) Aleutian Islands",
	/*003*/ "(UTC-10:00) Hawaii",
	/*004*/ "(UTC-09:30) Marquesas Islands",
	/*005*/ "(UTC-09:00) Alaska",
	/*006*/ "(UTC-09:00) Coordinated Universal Time-09",
	/*007*/ "(UTC-08:00) Baja California",
	/*008*/ "(UTC-08:00) Coordinated Universal Time-08",
	/*009*/ "(UTC-08:00) Pacific Time (US & Canada)",
	/*010*/ "(UTC-07:00) Arizona",
	/*011*/ "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
	/*012*/ "(UTC-07:00) Mountain Time (US & Canada)",
	/*013*/ "(UTC-06:00) Central America",
	/*014*/ "(UTC-06:00) Central Time (US & Canada)",
	/*015*/ "(UTC-06:00) Easter Island",
	/*016*/ "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
	/*017*/ "(UTC-06:00) Saskatchewan",
	/*018*/ "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
	/*019*/ "(UTC-05:00) Chetumal",
	/*020*/ "(UTC-05:00) Eastern Time (US & Canada)",
	/*021*/ "(UTC-05:00) Haiti",
	/*022*/ "(UTC-05:00) Havana",
	/*023*/ "(UTC-05:00) Indiana (East)",
	/*024*/ "(UTC-04:00) Asuncion",
	/*025*/ "(UTC-04:00) Atlantic Time (Canada)",
	/*026*/ "(UTC-04:00) Caracas",
	/*027*/ "(UTC-04:00) Cuiaba",
	/*028*/ "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
	/*029*/ "(UTC-04:00) Santiago",
	/*030*/ "(UTC-04:00) Turks and Caicos",
	/*031*/ "(UTC-03:30) Newfoundland",
	/*032*/ "(UTC-03:00) Araguaina",
	/*033*/ "(UTC-03:00) Brasilia",
	/*034*/ "(UTC-03:00) Cayenne, Fortaleza",
	/*035*/ "(UTC-03:00) City of Buenos Aires",
	/*036*/ "(UTC-03:00) Greenland",
	/*037*/ "(UTC-03:00) Montevideo",
	/*038*/ "(UTC-03:00) Saint Pierre and Miquelon",
	/*039*/ "(UTC-03:00) Salvador",
	/*040*/ "(UTC-02:00) Coordinated Universal Time-02",
	/*041*/ "(UTC-01:00) Azores",
	/*042*/ "(UTC-01:00) Cabo Verde Is.",
	/*043*/ "(UTC) Coordinated Universal Time",
	/*044*/ "(UTC+00:00) Casablanca",
	/*045*/ "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
	/*046*/ "(UTC+00:00) Monrovia, Reykjavik",
	/*047*/ "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
	/*048*/ "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
	/*049*/ "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
	/*050*/ "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
	/*051*/ "(UTC+01:00) West Central Africa",
	/*052*/ "(UTC+01:00) Windhoek",
	/*053*/ "(UTC+02:00) Amman",
	/*054*/ "(UTC+02:00) Athens, Bucharest",
	/*055*/ "(UTC+02:00) Beirut",
	/*056*/ "(UTC+02:00) Cairo",
	/*057*/ "(UTC+02:00) Chisinau",
	/*058*/ "(UTC+02:00) Damascus",
	/*059*/ "(UTC+02:00) Gaza, Hebron",
	/*060*/ "(UTC+02:00) Harare, Pretoria",
	/*061*/ "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
	/*062*/ "(UTC+02:00) Istanbul",
	/*063*/ "(UTC+02:00) Jerusalem",
	/*064*/ "(UTC+02:00) Kaliningrad",
	/*065*/ "(UTC+02:00) Tripoli",
	/*066*/ "(UTC+03:00) Baghdad",
	/*067*/ "(UTC+03:00) Kuwait, Riyadh",
	/*068*/ "(UTC+03:00) Minsk",
	/*069*/ "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
	/*070*/ "(UTC+03:00) Nairobi",
	/*071*/ "(UTC+03:30) Tehran",
	/*072*/ "(UTC+04:00) Abu Dhabi, Muscat",
	/*073*/ "(UTC+04:00) Astrakhan, Ulyanovsk",
	/*074*/ "(UTC+04:00) Baku",
	/*075*/ "(UTC+04:00) Izhevsk, Samara",
	/*076*/ "(UTC+04:00) Port Louis",
	/*077*/ "(UTC+04:00) Tbilisi",
	/*078*/ "(UTC+04:00) Yerevan",
	/*079*/ "(UTC+04:30) Kabul",
	/*080*/ "(UTC+05:00) Ashgabat, Tashkent",
	/*081*/ "(UTC+05:00) Ekaterinburg",
	/*082*/ "(UTC+05:00) Islamabad, Karachi",
	/*083*/ "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
	/*084*/ "(UTC+05:30) Sri Jayawardenepura",
	/*085*/ "(UTC+05:45) Kathmandu",
	/*086*/ "(UTC+06:00) Astana",
	/*087*/ "(UTC+06:00) Dhaka",
	/*088*/ "(UTC+06:00) Omsk",
	/*089*/ "(UTC+06:30) Yangon (Rangoon)",
	/*090*/ "(UTC+07:00) Bangkok, Hanoi, Jakarta",
	/*091*/ "(UTC+07:00) Barnaul, Gorno-Altaysk",
	/*092*/ "(UTC+07:00) Hovd",
	/*093*/ "(UTC+07:00) Krasnoyarsk",
	/*094*/ "(UTC+07:00) Novosibirsk",
	/*095*/ "(UTC+07:00) Tomsk",
	/*096*/ "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
	/*097*/ "(UTC+08:00) Irkutsk",
	/*098*/ "(UTC+08:00) Kuala Lumpur, Singapore",
	/*099*/ "(UTC+08:00) Perth",
	/*100*/ "(UTC+08:00) Taipei",
	/*101*/ "(UTC+08:00) Ulaanbaatar",
	/*102*/ "(UTC+08:30) Pyongyang",
	/*103*/ "(UTC+08:45) Eucla",
	/*104*/ "(UTC+09:00) Chita",
	/*105*/ "(UTC+09:00) Osaka, Sapporo, Tokyo",
	/*106*/ "(UTC+09:00) Seoul",
	/*107*/ "(UTC+09:00) Yakutsk",
	/*108*/ "(UTC+09:30) Adelaide",
	/*109*/ "(UTC+09:30) Darwin",
	/*110*/ "(UTC+10:00) Brisbane",
	/*111*/ "(UTC+10:00) Canberra, Melbourne, Sydney",
	/*112*/ "(UTC+10:00) Guam, Port Moresby",
	/*113*/ "(UTC+10:00) Hobart",
	/*114*/ "(UTC+10:00) Vladivostok",
	/*115*/ "(UTC+10:30) Lord Howe Island",
	/*116*/ "(UTC+11:00) Bougainville Island",
	/*117*/ "(UTC+11:00) Chokurdakh",
	/*118*/ "(UTC+11:00) Magadan",
	/*119*/ "(UTC+11:00) Norfolk Island",
	/*120*/ "(UTC+11:00) Sakhalin",
	/*121*/ "(UTC+11:00) Solomon Is., New Caledonia",
	/*122*/ "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
	/*123*/ "(UTC+12:00) Auckland, Wellington",
	/*124*/ "(UTC+12:00) Coordinated Universal Time+12",
	/*125*/ "(UTC+12:00) Fiji",
	/*126*/ "(UTC+12:45) Chatham Islands",
	/*127*/ "(UTC+13:00) Nuku'alofa",
	/*128*/ "(UTC+13:00) Samoa",
	/*129*/ "(UTC+14:00) Kiritimati Island"
],
olsonTZ = {
    "Etc/GMT+12": 0,
    "Pacific/Pago_Pago": 1,
    "Pacific/Niue": 1,
    "Pacific/Midway": 1,
    "Etc/GMT+11": 1,
    "America/Adak": 2,
    "Pacific/Rarotonga": 3,
    "Pacific/Tahiti": 3,
    "Pacific/Johnston": 3,
    "Pacific/Honolulu": 3,
    "Etc/GMT+10": 3,
    "Pacific/Marquesas": 4,
    "America/Anchorage": 5,
    "America/Juneau": 5,
    "America/Metlakatla": 5,
    "America/Nome": 5,
    "America/Sitka": 5,
    "America/Yakutat": 5,
    "Pacific/Gambier": 6,
    "Etc/GMT+9": 6,
    "America/Tijuana": 7,
    "America/Santa_Isabel": 7,
    "Pacific/Pitcairn": 8,
    "Etc/GMT+8": 8,
    "America/Vancouver": 9,
    "America/Dawson": 9,
    "America/Whitehorse": 9,
    "America/Los_Angeles": 9,
    "PST8PDT": 9,
    "America/Dawson_Creek": 10,
    "America/Creston": 10,
    "America/Fort_Nelson": 10,
    "America/Hermosillo": 10,
    "America/Phoenix": 10,
    "Etc/GMT+7": 10,
    "America/Chihuahua": 11,
    "America/Mazatlan": 11,
    "America/Edmonton": 12,
    "America/Cambridge_Bay": 12,
    "America/Inuvik": 12,
    "America/Yellowknife": 12,
    "America/Ojinaga": 12,
    "America/Denver": 12,
    "America/Boise": 12,
    "MST7MDT": 12,
    "America/Belize": 13,
    "America/Costa_Rica": 13,
    "Pacific/Galapagos": 13,
    "America/Guatemala": 13,
    "America/Tegucigalpa": 13,
    "America/Managua": 13,
    "America/El_Salvador": 13,
    "Etc/GMT+6": 13,
    "America/Winnipeg": 14,
    "America/Rainy_River": 14,
    "America/Rankin_Inlet": 14,
    "America/Resolute": 14,
    "America/Matamoros": 14,
    "America/Chicago": 14,
    "America/Indiana/Knox": 14,
    "America/Indiana/Tell_City": 14,
    "America/Menominee": 14,
    "America/North_Dakota/Beulah": 14,
    "America/North_Dakota/Center": 14,
    "America/North_Dakota/New_Salem": 14,
    "CST6CDT": 14,
    "Pacific/Easter": 15,
    "America/Mexico_City": 16,
    "America/Bahia_Banderas": 16,
    "America/Merida": 16,
    "America/Monterrey": 16,
    "America/Regina": 17,
    "America/Swift_Current": 17,
    "America/Rio_Branco": 18,
    "America/Eirunepe": 18,
    "America/Coral_Harbour": 18,
    "America/Bogota": 18,
    "America/Guayaquil": 18,
    "America/Jamaica": 18,
    "America/Cayman": 18,
    "America/Panama": 18,
    "America/Lima": 18,
    "Etc/GMT+5": 18,
    "America/Cancun": 19,
    "America/Nassau": 20,
    "America/Toronto": 20,
    "America/Iqaluit": 20,
    "America/Montreal": 20,
    "America/Nipigon": 20,
    "America/Pangnirtung": 20,
    "America/Thunder_Bay": 20,
    "America/New_York": 20,
    "America/Detroit": 20,
    "America/Indiana/Petersburg": 20,
    "America/Indiana/Vincennes": 20,
    "America/Indiana/Winamac": 20,
    "America/Kentucky/Monticello": 20,
    "America/Louisville": 20,
    "EST5EDT": 20,
    "America/Port-au-Prince": 21,
    "America/Havana": 22,
    "America/Indianapolis": 23,
    "America/Indiana/Marengo": 23,
    "America/Indiana/Vevay": 23,
    "America/Asuncion": 24,
    "Atlantic/Bermuda": 25,
    "America/Halifax": 25,
    "America/Glace_Bay": 25,
    "America/Goose_Bay": 25,
    "America/Moncton": 25,
    "America/Thule": 25,
    "America/Caracas": 26,
    "America/Cuiaba": 27,
    "America/Campo_Grande": 27,
    "America/Antigua": 28,
    "America/Anguilla": 28,
    "America/Aruba": 28,
    "America/Barbados": 28,
    "America/St_Barthelemy": 28,
    "America/La_Paz": 28,
    "America/Kralendijk": 28,
    "America/Manaus": 28,
    "America/Boa_Vista": 28,
    "America/Porto_Velho": 28,
    "America/Blanc-Sablon": 28,
    "America/Curacao": 28,
    "America/Dominica": 28,
    "America/Santo_Domingo": 28,
    "America/Grenada": 28,
    "America/Guadeloupe": 28,
    "America/Guyana": 28,
    "America/St_Kitts": 28,
    "America/St_Lucia": 28,
    "America/Marigot": 28,
    "America/Martinique": 28,
    "America/Montserrat": 28,
    "America/Puerto_Rico": 28,
    "America/Lower_Princes": 28,
    "America/Port_of_Spain": 28,
    "America/St_Vincent": 28,
    "America/Tortola": 28,
    "America/St_Thomas": 28,
    "Etc/GMT+4": 28,
    "Antarctica/Palmer": 29,
    "America/Santiago": 29,
    "America/Grand_Turk": 30,
    "America/St_Johns": 31,
    "America/Araguaina": 32,
    "America/Sao_Paulo": 33,
    "Antarctica/Rothera": 34,
    "America/Fortaleza": 34,
    "America/Belem": 34,
    "America/Maceio": 34,
    "America/Recife": 34,
    "America/Santarem": 34,
    "Atlantic/Stanley": 34,
    "America/Cayenne": 34,
    "America/Paramaribo": 34,
    "Etc/GMT+3": 34,
    "America/Buenos_Aires": 35,
    "America/Argentina/La_Rioja": 35,
    "America/Argentina/Rio_Gallegos": 35,
    "America/Argentina/Salta": 35,
    "America/Argentina/San_Juan": 35,
    "America/Argentina/San_Luis": 35,
    "America/Argentina/Tucuman": 35,
    "America/Argentina/Ushuaia": 35,
    "America/Catamarca": 35,
    "America/Cordoba": 35,
    "America/Jujuy": 35,
    "America/Mendoza": 35,
    "America/Godthab": 36,
    "America/Montevideo": 37,
    "America/Miquelon": 38,
    "America/Bahia": 39,
    "America/Noronha": 40,
    "Atlantic/South_Georgia": 40,
    "Etc/GMT+2": 40,
    "America/Scoresbysund": 41,
    "Atlantic/Azores": 41,
    "Atlantic/Cape_Verde": 42,
    "Etc/GMT+1": 42,
    "America/Danmarkshavn": 43,
    "Etc/GMT": 43,
    "Africa/El_Aaiun": 44,
    "Africa/Casablanca": 44,
    "Atlantic/Canary": 45,
    "Atlantic/Faeroe": 45,
    "Europe/London": 45,
    "Europe/Guernsey": 45,
    "Europe/Dublin": 45,
    "Europe/Isle_of_Man": 45,
    "Europe/Jersey": 45,
    "Europe/Lisbon": 45,
    "Atlantic/Madeira": 45,
    "Africa/Ouagadougou": 46,
    "Africa/Abidjan": 46,
    "Africa/Accra": 46,
    "Africa/Banjul": 46,
    "Africa/Conakry": 46,
    "Africa/Bissau": 46,
    "Atlantic/Reykjavik": 46,
    "Africa/Monrovia": 46,
    "Africa/Bamako": 46,
    "Africa/Nouakchott": 46,
    "Atlantic/St_Helena": 46,
    "Africa/Freetown": 46,
    "Africa/Dakar": 46,
    "Africa/Sao_Tome": 46,
    "Africa/Lome": 46,
    "Europe/Andorra": 47,
    "Europe/Vienna": 47,
    "Europe/Zurich": 47,
    "Europe/Berlin": 47,
    "Europe/Busingen": 47,
    "Europe/Gibraltar": 47,
    "Europe/Rome": 47,
    "Europe/Vaduz": 47,
    "Europe/Luxembourg": 47,
    "Europe/Monaco": 47,
    "Europe/Malta": 47,
    "Europe/Amsterdam": 47,
    "Europe/Oslo": 47,
    "Europe/Stockholm": 47,
    "Arctic/Longyearbyen": 47,
    "Europe/San_Marino": 47,
    "Europe/Vatican": 47,
    "Europe/Tirane": 48,
    "Europe/Prague": 48,
    "Europe/Budapest": 48,
    "Europe/Podgorica": 48,
    "Europe/Belgrade": 48,
    "Europe/Ljubljana": 48,
    "Europe/Bratislava": 48,
    "Europe/Brussels": 49,
    "Europe/Copenhagen": 49,
    "Europe/Madrid": 49,
    "Africa/Ceuta": 49,
    "Europe/Paris": 49,
    "Europe/Sarajevo": 50,
    "Europe/Zagreb": 50,
    "Europe/Skopje": 50,
    "Europe/Warsaw": 50,
    "Africa/Luanda": 51,
    "Africa/Porto-Novo": 51,
    "Africa/Kinshasa": 51,
    "Africa/Bangui": 51,
    "Africa/Brazzaville": 51,
    "Africa/Douala": 51,
    "Africa/Algiers": 51,
    "Africa/Libreville": 51,
    "Africa/Malabo": 51,
    "Africa/Niamey": 51,
    "Africa/Lagos": 51,
    "Africa/Ndjamena": 51,
    "Africa/Tunis": 51,
    "Etc/GMT-1": 51,
    "Africa/Windhoek": 52,
    "Asia/Amman": 53,
    "Asia/Nicosia": 54,
    "Europe/Athens": 54,
    "Europe/Bucharest": 54,
    "Asia/Beirut": 55,
    "Africa/Cairo": 56,
    "Europe/Chisinau": 57,
    "Asia/Damascus": 58,
    "Asia/Hebron": 59,
    "Asia/Gaza": 59,
    "Africa/Bujumbura": 60,
    "Africa/Gaborone": 60,
    "Africa/Lubumbashi": 60,
    "Africa/Maseru": 60,
    "Africa/Blantyre": 60,
    "Africa/Maputo": 60,
    "Africa/Kigali": 60,
    "Africa/Mbabane": 60,
    "Africa/Johannesburg": 60,
    "Africa/Lusaka": 60,
    "Africa/Harare": 60,
    "Etc/GMT-2": 60,
    "Europe/Mariehamn": 61,
    "Europe/Sofia": 61,
    "Europe/Tallinn": 61,
    "Europe/Helsinki": 61,
    "Europe/Vilnius": 61,
    "Europe/Riga": 61,
    "Europe/Kiev": 61,
    "Europe/Uzhgorod": 61,
    "Europe/Zaporozhye": 61,
    "Europe/Istanbul": 62,
    "Asia/Jerusalem": 63,
    "Europe/Kaliningrad": 64,
    "Africa/Tripoli": 65,
    "Asia/Baghdad": 66,
    "Asia/Bahrain": 67,
    "Asia/Kuwait": 67,
    "Asia/Qatar": 67,
    "Asia/Riyadh": 67,
    "Asia/Aden": 67,
    "Europe/Minsk": 68,
    "Europe/Moscow": 69,
    "Europe/Kirov": 69,
    "Europe/Volgograd": 69,
    "Europe/Simferopol": 69,
    "Antarctica/Syowa": 70,
    "Africa/Djibouti": 70,
    "Africa/Asmera": 70,
    "Africa/Addis_Ababa": 70,
    "Africa/Nairobi": 70,
    "Indian/Comoro": 70,
    "Indian/Antananarivo": 70,
    "Africa/Khartoum": 70,
    "Africa/Mogadishu": 70,
    "Africa/Juba": 70,
    "Africa/Dar_es_Salaam": 70,
    "Africa/Kampala": 70,
    "Indian/Mayotte": 70,
    "Etc/GMT-3": 70,
    "Asia/Tehran": 71,
    "Asia/Dubai": 72,
    "Asia/Muscat": 72,
    "Etc/GMT-4": 72,
    "Europe/Astrakhan": 73,
    "Europe/Saratov": 73,
    "Europe/Ulyanovsk": 73,
    "Asia/Baku": 74,
    "Europe/Samara": 75,
    "Indian/Mauritius": 76,
    "Indian/Reunion": 76,
    "Indian/Mahe": 76,
    "Asia/Tbilisi": 77,
    "Asia/Yerevan": 78,
    "Asia/Kabul": 79,
    "Antarctica/Mawson": 80,
    "Asia/Oral": 80,
    "Asia/Aqtau": 80,
    "Asia/Aqtobe": 80,
    "Asia/Atyrau": 80,
    "Indian/Maldives": 80,
    "Indian/Kerguelen": 80,
    "Asia/Dushanbe": 80,
    "Asia/Ashgabat": 80,
    "Asia/Tashkent": 80,
    "Asia/Samarkand": 80,
    "Etc/GMT-5": 80,
    "Asia/Yekaterinburg": 81,
    "Asia/Karachi": 82,
    "Asia/Calcutta": 83,
    "Asia/Colombo": 84,
    "Asia/Katmandu": 85,
    "Antarctica/Vostok": 86,
    "Asia/Urumqi": 86,
    "Indian/Chagos": 86,
    "Asia/Bishkek": 86,
    "Asia/Almaty": 86,
    "Asia/Qyzylorda": 86,
    "Etc/GMT-6": 86,
    "Asia/Dhaka": 87,
    "Asia/Thimphu": 87,
    "Asia/Omsk": 88,
    "Indian/Cocos": 89,
    "Asia/Rangoon": 89,
    "Antarctica/Davis": 90,
    "Indian/Christmas": 90,
    "Asia/Jakarta": 90,
    "Asia/Pontianak": 90,
    "Asia/Phnom_Penh": 90,
    "Asia/Vientiane": 90,
    "Asia/Bangkok": 90,
    "Asia/Saigon": 90,
    "Etc/GMT-7": 90,
    "Asia/Barnaul": 91,
    "Asia/Hovd": 92,
    "Asia/Krasnoyarsk": 93,
    "Asia/Novokuznetsk": 93,
    "Asia/Novosibirsk": 94,
    "Asia/Tomsk": 95,
    "Asia/Shanghai": 96,
    "Asia/Hong_Kong": 96,
    "Asia/Macau": 96,
    "Asia/Irkutsk": 97,
    "Asia/Brunei": 98,
    "Asia/Makassar": 98,
    "Asia/Kuala_Lumpur": 98,
    "Asia/Kuching": 98,
    "Asia/Manila": 98,
    "Asia/Singapore": 98,
    "Etc/GMT-8": 98,
    "Australia/Perth": 99,
    "Asia/Taipei": 100,
    "Asia/Ulaanbaatar": 101,
    "Asia/Choibalsan": 101,
    "Asia/Pyongyang": 102,
    "Australia/Eucla": 103,
    "Asia/Chita": 104,
    "Asia/Jayapura": 105,
    "Asia/Tokyo": 105,
    "Pacific/Palau": 105,
    "Asia/Dili": 105,
    "Etc/GMT-9": 105,
    "Asia/Seoul": 106,
    "Asia/Yakutsk": 107,
    "Asia/Khandyga": 107,
    "Australia/Adelaide": 108,
    "Australia/Broken_Hill": 108,
    "Australia/Darwin": 109,
    "Australia/Brisbane": 110,
    "Australia/Lindeman": 110,
    "Australia/Sydney": 111,
    "Australia/Melbourne": 111,
    "Antarctica/DumontDUrville": 112,
    "Pacific/Truk": 112,
    "Pacific/Guam": 112,
    "Pacific/Saipan": 112,
    "Pacific/Port_Moresby": 112,
    "Etc/GMT-10": 112,
    "Australia/Hobart": 113,
    "Australia/Currie": 113,
    "Asia/Vladivostok": 114,
    "Asia/Ust-Nera": 114,
    "Australia/Lord_Howe": 115,
    "Pacific/Bougainville": 116,
    "Asia/Srednekolymsk": 117,
    "Asia/Magadan": 118,
    "Pacific/Norfolk": 119,
    "Asia/Sakhalin": 120,
    "Antarctica/Casey": 121,
    "Antarctica/Macquarie": 121,
    "Pacific/Ponape": 121,
    "Pacific/Kosrae": 121,
    "Pacific/Noumea": 121,
    "Pacific/Guadalcanal": 121,
    "Pacific/Efate": 121,
    "Etc/GMT-11": 121,
    "Asia/Kamchatka": 122,
    "Asia/Anadyr": 122,
    "Antarctica/McMurdo": 123,
    "Pacific/Auckland": 123,
    "Pacific/Tarawa": 124,
    "Pacific/Majuro": 124,
    "Pacific/Kwajalein": 124,
    "Pacific/Nauru": 124,
    "Pacific/Funafuti": 124,
    "Pacific/Wake": 124,
    "Pacific/Wallis": 124,
    "Etc/GMT-12": 124,
    "Pacific/Fiji": 125,
    "Pacific/Chatham": 126,
    "Pacific/Enderbury": 127,
    "Pacific/Fakaofo": 127,
    "Pacific/Tongatapu": 127,
    "Etc/GMT-13": 127,
    "Pacific/Apia": 128,
    "Pacific/Kiritimati": 129,
    "Etc/GMT-14": 129,
};
//#endregion

function getTZString() {
	var t = new Date(new Date().getFullYear(), 0, 1).getTimezoneOffset();
	var r = t > 0 ? "-" : "+"; t = Math.abs(t);
	var h = Math.floor(t / 60), m = t % 60;
	r += (h > 10 ? "" : "0") + h + ":" + (m > 10 ? "" : "0") + m;
	return "(UTC" + r + ")";
}

function selectByTextPrefix(select, value) {
	var oo = select.options, l = oo.length;
	// first item is autoselected?
	if(l && oo[0].selected && !oo[0].defaultSelected) {
		for(var i = 0; i < l; i++) {
			var o = oo[i];
			if(!o.text.indexOf(value)) {
				o.selected = true;
				return true;
			}
		}
	}
}

$.fn.initTZ = function() {
	var tz;
	if(window.Intl && Intl.DateTimeFormat && Intl.DateTimeFormat.prototype && Intl.DateTimeFormat.prototype.resolvedOptions)
	    tz = winTZ[olsonTZ[Intl.DateTimeFormat().resolvedOptions().timeZone]];
	var tzString = getTZString(); 

	return this.each(function() {
		tz && selectByTextPrefix(this, tz) || selectByTextPrefix(this, tzString);
	});
};